export default __webpack_public_path__ + "assets/009ec8a017ea22a79811d69514f459c8.woff";